import { InputElementType, InputType } from './input.types';

export const DEFAULT_INPUT_TYPE: InputType = 'text';
export const DEFAULT_INPUT_ELEMENT_TYPE: InputElementType = 'input';
export const ICON_FOR_CALENDAR = 'bds/calendar/24';
export const ICON_FOR_NOT_VISIBLE_PASSWORD = 'bds/eye/16';
export const ICON_FOR_VISIBLE_PASSWORD = 'bds/no-eye/16';
export const INPUT_PASSWORD_TYPE: InputType = 'password';
export const INPUT_DATE_TYPE: InputType = 'date';
export const SPECIAL_ACTION_CLASS = 'special-action-button';
export const CLICK_THROUGH_MODIFIER_CLASS = 'is-click-through';
